<template>
  <div
    id="kt_header_mobile"
    class="header-mobile align-items-center"
    v-bind:class="headerClasses"
  >
    <!--begin::Logo-->
    <a href="/">
      <img alt="Logo" :src="headerLogo" />
    </a>
    <!--end::Logo-->
    <!--begin::Toolbar-->
    <div class="d-flex align-items-center">
      <!--begin::Aside Mobile Toggle-->
      <button
        v-if="asideEnabled"
        class="btn p-0 burger-icon burger-icon-left"
        id="kt_aside_mobile_toggle"
      >
        <span></span>
      </button>
      <!--end::Aside Mobile Toggle-->
      <!--begin::Header Menu Mobile Toggle-->
      <!-- <button
        class="btn p-0 burger-icon ml-4"
        id="kt_header_mobile_toggle"
        ref="kt_header_mobile_toggle"
      >
        <span></span>
      </button> -->
      <!--end::Header Menu Mobile Toggle-->
      <!--begin::Topbar Mobile Toggle-->
      <button
        class="btn btn-hover-text-primary p-0 ml-2 kt_quick_user_toggle"
        id="kt_quick_user_toggle"
        ref="kt_quick_user_toggle"
        
      >
        <!-- @click="showMenu" -->
          <img class="img-mobile" alt="Pic" :src="picture" />
        <!-- <span class="svg-icon svg-icon-xl"> -->
        <!--begin::Svg Icon | path:svg/icons/General/User.svg-->
        <!-- <inline-svg class="svg-icon" src="media/svg/icons/General/User.svg" /> -->
        <!--end::Svg Icon-->
        <!-- </span> -->
      </button>
      <!--end::Topbar Mobile Toggle-->
    </div>
    <!--end::Toolbar-->
  </div>
</template>
<style scoped>
.img-mobile {
  width: 24px;
  height: 24px;
}
</style>
<script>
import { mapGetters } from "vuex";
import KTLayoutHeaderTopbar from "@/assets/js/layout/base/header-topbar.js";
import httpHelper from "@/helpers/httpHelper";
import sessionHelper from "@/helpers/sessionHelper";
import routesMap from '@/helpers/routesMap'

export default {
  name: "KTHeaderMobile",
  components: {},
  data() {
    return {
      user: {},
      picture: "media/users/default-mobile.jpg",
      list: [
        // {
        //   title: "طراحی پنل جدید",
        //   desc: "2 روز پیش",
        //   alt: "+28%",
        //   svg: "media/svg/icons/Home/Library.svg",
        //   type: "warning"
        // }
      ],
      routesMap,
    };
  },
  methods:{
    // showMenu(){
    //   //kt_quick_user
    //   document.body.className += ' offcanvas-on';
    //   document.getElementById('kt_quick_user').className += ' offcanvas-on';
    // }
  },
  mounted() {
    // Init Header Topbar For Mobile Mode
    //KTLayoutHeaderTopbar.init(this.$refs["kt_header_mobile_topbar_toggle"]);
    httpHelper.setAuth();
    httpHelper.getData("users/verify").then((res) => {
      this.user = res;
      if (this.user.image_profile != null && this.user.image_profile != "") {
        httpHelper.getImage(this.user.image_profile).then((res) => {
          this.picture = res.result.url;
        });
      }
      // sessionHelper.setUser(res);
      // if (
      //   this.user.phonestatus == 1520 ||
      //   this.user.nationalstatus == 1520 ||
      //   this.user.selfiestatus == 1520
      // ) {
      //   this.$router.push("/user/conf");
      // }
    });
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Get header logo
     * @returns {string}
     */
    headerLogo() {
      return process.env.BASE_URL + this.layoutConfig("self.logo.dark");
    },

    /**
     * Get classes for mobile header
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header_mobile");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
  },
};
</script>
